export const rfqModelName = 'requestforquote';
export const tdsModelName = 'technicaldatasheet';
export const dealModelName = 'deal';
